import React from 'react';
import { motion } from 'framer-motion';

const DisclaimerPage = ({ onBack }) => {
  return (
    <div style={{ backgroundColor: '#ffffff', minHeight: '100vh' }}>
      {/* Back Button */}
      <motion.div 
        style={{ 
          padding: '20px',
          position: 'fixed',
          top: '20px',
          left: '20px',
          zIndex: 1000
        }}
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6 }}
      >
        <button 
          onClick={onBack}
          style={{
            background: '#7c3aed',
            color: 'white',
            border: 'none',
            padding: '12px 24px',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: '600',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            boxShadow: '0 4px 12px rgba(124, 58, 237, 0.3)',
            transition: 'all 0.3s ease'
          }}
          onMouseOver={(e) => {
            e.target.style.background = '#6d28d9';
            e.target.style.transform = 'translateY(-2px)';
          }}
          onMouseOut={(e) => {
            e.target.style.background = '#7c3aed';
            e.target.style.transform = 'translateY(0px)';
          }}
        >
          ← Back to Home
        </button>
      </motion.div>

      <motion.div 
        className="disclaimer-page"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        style={{
          padding: '120px 20px 50px 20px',
          maxWidth: '1200px',
          margin: '0 auto',
          lineHeight: '1.6',
          color: '#333',
          backgroundColor: '#ffffff'
        }}
      >
        <motion.h1 
          style={{
            fontSize: '3rem',
            marginBottom: '20px',
            color: '#7c3aed',
            textAlign: 'center'
          }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          ⚖️ Disclaimer
        </motion.h1>
        
        <motion.p 
          style={{
            fontSize: '1.2rem',
            fontWeight: 'bold',
            textAlign: 'center',
            marginBottom: '40px',
            color: '#7c3aed'
          }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          Effective Date: 20/12/2024
        </motion.p>

        <motion.div 
          style={{ marginBottom: '40px' }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          <ul style={{ paddingLeft: '20px', lineHeight: '2.5', fontSize: '1.1rem' }}>
            <li>LeadVala provides <strong>verified business leads</strong>, not guaranteed sales.</li>
            <li>Conversions depend on the client's sales process, market conditions, and follow-up.</li>
            <li>We make no warranties regarding profitability, business outcomes, or revenue.</li>
            <li>Ads and website content are for informational purposes only and do not constitute financial or legal advice.</li>
            <li>Use of our services is at your own risk.</li>
          </ul>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default DisclaimerPage;